// Captures an affiliate `?ref=` code on first load and persists it through the Clerk
// sign-up redirect and the Stripe Checkout redirect (both full-page navigations that
// wipe in-memory React state). Consumed by the signup flow when creating the org.

const KEY = 'bf_ref'
const TTL_MS = 30 * 24 * 60 * 60 * 1000 // 30 days

/** Read `?ref=` from the current URL and stash it (with a timestamp) in localStorage. */
export const captureRefFromUrl = () => {
    try {
        const ref = new URLSearchParams(window.location.search).get('ref')
        // Match the server promo-code shape (3–40 alphanumerics) so we never store a code that
        // could never resolve to an affiliate.
        if (ref && /^[A-Za-z0-9]{3,40}$/.test(ref)) {
            localStorage.setItem(KEY, JSON.stringify({ ref: ref.toUpperCase(), at: Date.now() }))
        }
    } catch {
        // ignore (private mode / unavailable storage)
    }
}

/** Return the stored referral code if present and not expired. */
export const getStoredRef = (): string | undefined => {
    try {
        const raw = localStorage.getItem(KEY)
        if (!raw) return undefined
        const { ref, at } = JSON.parse(raw) as { ref?: string; at?: number }
        if (!ref || typeof at !== 'number' || Date.now() - at > TTL_MS) return undefined
        return ref
    } catch {
        return undefined
    }
}

/** Clear the stored code once it has been consumed (one org per code per browser). */
export const clearStoredRef = () => {
    try {
        localStorage.removeItem(KEY)
    } catch {
        // ignore
    }
}
